var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ubiMainContPage",
      class: { device: _vm.device === "mobile" },
    },
    [
      _c(
        "div",
        {
          staticClass: "top-tips",
          class: { "en-top-tips": _vm.language === "en" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("ubi.topTipsTitle")) + "\n    "),
          _c("p", [_vm._v(_vm._s(_vm.$t("ubi.topTipsContent")))]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "custom-radio-group" }, [
        _c(
          "div",
          {
            staticClass: "custom-radio-item",
            class: { active: _vm.trackType === "" },
            on: {
              click: function ($event) {
                return _vm.changeTrackType("")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("trackingNo")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "custom-radio-item",
            class: { active: _vm.trackType === "0" },
            on: {
              click: function ($event) {
                return _vm.changeTrackType("0")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("consignmentId")))]
        ),
      ]),
      _vm._v(" "),
      _c("SearchAndResults", {
        attrs: { options: _vm.options, "track-type": _vm.trackType },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }